module.exports = __webpack_public_path__ + "static/media/20180522-LCS-023-9.c8714085.jpg";